import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/navbar";
import { Box, Button, Container, Stack } from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Footer } from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import Counter from "../components/Counter";
import { motion } from "framer-motion";
import HomeAptitude from "../components/HomeAptitude";
import CoursesCarousel from "../components/CoursesCarousel";
import HomePageWriteUpOne from "../components/HomePageWriteUpOne";
import FloatingButtons from "../components/FloatingButtons";

// YouTube video links configuration
const YOUTUBE_LINKS = {
  courseA: "https://www.youtube.com/watch?v=YOUR_COURSE_A_VIDEO_ID",
  courseB: "https://www.youtube.com/watch?v=YOUR_COURSE_B_VIDEO_ID",
  aptitudeTest: "https://www.youtube.com/watch?v=YOUR_APTITUDE_TEST_VIDEO_ID",
};

// YouTube Button Group Component
const YouTubeButtonGroup = ({ youtubeLink, section }) => {
  const navigate = useNavigate();

  const getNavigationPath = () => {
    switch (section) {
      case "courseA":
        return "/checkout";
      case "courseB":
        return "/checkout";
      case "aptitude":
        return "/category";
      default:
        return "/checkout";
    }
  };

  return (
    <Stack spacing={2} alignItems="center">
      <Button
        variant="contained"
        startIcon={<YouTubeIcon />}
        sx={{
          backgroundColor: "#FF0000",
          "&:hover": {
            backgroundColor: "#CC0000",
          },
          padding: "8px 16px",
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 500,
        }}
        onClick={() => window.open(youtubeLink, "_blank")}
      >
        Watch Video
      </Button>

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#30B0C7",
          "&:hover": {
            backgroundColor: "#2798ac",
          },
          height: "60px",
          width: "250px",
          borderRadius: "30px",
          textTransform: "none",
          fontWeight: 500,
        }}
        onClick={() => navigate("/admission")}
      >
        Register Now!
      </Button>
    </Stack>
  );
};

const Home = () => {
  const aptitudeTestData = {
    title: "APTITUDE EVALUATION TEST",
    image: "/poster/Aptitude test.png",
    youtubeLink: "https://youtube.com/shorts/1SchqpTk3Zw?feature=share",
    features: [
      {
        title: "Eligibility & Domains",
        icon: "schedule-pic.png",
        details: [
          "Open to senior secondary pass-outs, graduates, and professionals.",
          "Explore careers in specialized or non-specialized fields.",
        ],
      },
      {
        title: "Evaluation Process",
        icon: "knowledge-sharing-pic.png",
        details: [
          "Test assess Skill, Knowledge, IQ, EQ, Decision Making, Interest, Behaviour, etc.",
          "Provides a two-level evaluation report with par scores.",
        ],
      },
      {
        title: "Evaluation & Support",
        icon: "goal-pic.png",
        details: [
          "Students meeting par scores receive a detailed career path report.",
          "Offers personalized insights for career validation.",
        ],
      },
    ],
  };

  const navigate = useNavigate();
  const coverImgRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(entry.isIntersecting);
        });
      },
      { threshold: 0.5 },
    );

    if (coverImgRef.current) {
      observer.observe(coverImgRef.current);
    }

    return () => {
      if (coverImgRef.current) {
        observer.unobserve(coverImgRef.current);
      }
    };
  }, []);

  return (
    <div className="home-background" style={{ padding: "0px" }}>
      <style jsx global>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");

        .animate-slide-in {
          animation: slideIn 0.5s ease-out forwards;
          opacity: 0;
          transform: translateX(-20px);
        }

        @keyframes slideIn {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes notificationPulse {
          0% {
            opacity: 1;
            transform: translateX(0);
            text-shadow: 0 0 0 rgba(255, 0, 0, 0);
          }
          50% {
            opacity: 0.9;
            transform: translateX(5px);
            text-shadow: 2px 2px 4px rgba(255, 0, 0, 0.3);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
            text-shadow: 0 0 0 rgba(255, 0, 0, 0);
          }
        }

        .animate-notification {
          animation: notificationPulse 3s infinite;
          display: inline-block;
          font-family: "Poppins", sans-serif;
        }

        .notification-group:nth-child(1) {
          animation-delay: 0s;
        }
        .notification-group:nth-child(2) {
          animation-delay: 0.2s;
        }
        .notification-group:nth-child(3) {
          animation-delay: 0.4s;
        }
        .notification-group:nth-child(4) {
          animation-delay: 0.6s;
        }

        .notification-group:nth-child(1) .animate-notification {
          animation-delay: 0.5s;
        }
        .notification-group:nth-child(2) .animate-notification {
          animation-delay: 1s;
        }
        .notification-group:nth-child(3) .animate-notification {
          animation-delay: 1.5s;
        }
        .notification-group:nth-child(4) .animate-notification {
          animation-delay: 2s;
        }

        .about-para {
          font-size: 20px;
        }

        @media (max-width: 1200px) {
          .about-para {
            font-size: 16px;
          }
        }
      `}</style>
      <Navbar />
      <Box
        style={{
          height: {
            xs: "89vh",
            sm: "85vh",
          },
          width: "100%",
        }}
      >
        <div className="cover">
          <div className="container-1">
            <motion.div
              className="col-6"
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              {/* <img src='logo.png' className='logo' /> */}
              <p className="heading">
                Crafting a <br /> career that suits <br /> you the most.
              </p>
              {/* <p className="subheading">
                Discover your true skills and academics with an evaluation
                report guiding you to the right career path.
              </p> */}

              {/* Button with Separate Animation */}
              <motion.button
                className="services"
                onClick={() => navigate("/courses")}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }} // Delayed appearance
                whileHover={{ scale: 1.05 }} // Slight hover effect
              >
                Our Services
              </motion.button>
            </motion.div>
          </div>
          <div className="container-2">
            <div className="cover-content">
              <p className={`cover-title ${isVisible ? "visible" : ""}`}>
                FUNDED BY
              </p>
              <img
                className="cover-img"
                src="image 21.png"
                ref={coverImgRef}
                alt="Funded By Logo"
              />
            </div>
          </div>
        </div>
      </Box>

      <div style={{ width: "100%" }}>
        {/* About Section */}
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="row"
            style={{
              // height: "100%",
              width: "80%",
              padding: "0 20px",
              boxShadow: "0px 2px 20px #bebebe",
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
              alignContent: "center",
              borderRadius: "20px",
              alignItems: "center",
              zIndex: 1,
              backgroundColor: "white",
            }}
          >
            <div
              className="col-sm-12 col-md-5"
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0px auto",
              }}
            >
              <img src="logo.png" style={{ height: "70%", width: "70%" }} />
            </div>
            <HomePageWriteUpOne />
          </div>
        </div>

        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            mt: { xs: 2, sm: 3 },
          }}
        >
          <Button
            variant="contained"
            onClick={() => navigate("/initial-info")}
            sx={{
              backgroundColor: "#30B0C7",
              "&:hover": {
                backgroundColor: "#2798ac",
              },

              width: { xs: "80%", sm: "385px" }, // 👈 full width on mobile
              maxWidth: "385px",
              height: { xs: "48px", sm: "66px" }, // 👈 responsive height

              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "15px", sm: "16px" },

              transition: "all 0.2s ease",
              "&:active": {
                transform: "scale(0.97)",
              },
            }}
          >
            Go to Counselling
          </Button>
        </Box> */}
        <div>
          <motion.p
            className="slogan"
            initial={{ opacity: 0, rotateX: 90 }} // Starts flat (sleeping)
            whileInView={{ opacity: 1, rotateX: 0 }} // Stands up when in view
            transition={{
              duration: 1.6,
              ease: "easeOut",
              type: "spring",
              stiffness: 80,
            }}
            viewport={{ once: false }} // Triggers only once when in view
            style={{ transformOrigin: "bottom" }} // Ensures it flips from the bottom
          >
            ✨ Discover. Dream. Do. — With Yapassio!
          </motion.p>
        </div>
        {/* <div className="course-carousel-container">
          <CoursesCarousel />
        </div> */}
        {/* <CourseDetails course={courseA} />;
        <CourseDetails course={courseBProps} /> */}
        <style>
          {`
            /* Container Styling */
            .course-container {
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding: 0px;
              width: 80vw;
              margin-top: 30px;
            }

            .course-title {
              text-align: center;
              font-family: Aclonica;
              font-size: 48px;
            }

            /* Grid Styles */
            .responsive-grid {
              font-family:Inter;
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: auto;
              gap: 14px;
            }

            .grid-item {
              font-size:18px;
              background-color: #97D7E280;
              border-radius: 20px;
              padding: 20px;
            }
            .apt{
              grid-column: 1 / 3;
              
            }
            .grid-item:hover{
              transform:scale(1.02);
              transition:transform 0.3s;
            }

            .grid-header {
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .icon {
              height: 35px;
              width: 35px;
            }

            /* Course Image */
            .course-image {
              grid-row: 1 / 3;
              grid-column: 2 / 3;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #031534;
              border-radius: 20px;
            }

            .course-image img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              border-radius: 20px;
            }

            .action-container{
              width:60vw;
              display:flex;
              gap:15px;
              justify-content:center;
              align-items:center;
            }

            .item-para{
              font-size:1.7vw;
            }
            @media(min-width:1550px){
              .item-para{
                font-size:1.5vw;
              }
              .para-header {
                font-size:1.7vw;
              }
              .grid-item{
                padding:2vw;
              }
            }
           
            

            .slogan{
              text-align: center;
              font-size: 40px;
              font-family: Aclonica;
              margin-top: 30px;
              margin-bottom: 0px;
            }

            /* Mobile Responsive - Single Column */
            @media (max-width: 760px) {

              
              .responsive-grid {
                display: flex;
                flex-direction: column;
                gap: 10px;
              }
              .slogan{
                text-align: center;
                font-size: 30px;
                font-family: Aclonica;
                margin-top: 30px;
                margin-bottom: 0px;
              }

              .item-para{
                font-size:16px;
              }
              .course-image {
                order: -1; /* Moves the image to the top */
              }
              .course-title{
                font-size:36px;
              }
            }
            @media (max-width: 448px) {
              
              .item-para{
                font-size:4vw;
              }
              .course-image {
                order: -1; /* Moves the image to the top */
              }
            }
            @media (max-width: 330px) {
              .item-para{
                font-size:5vw;
              }
            }
            @media (max-width: 1200px) {
              .responsive-grid {
                display: flex;
                flex-direction: column;
                gap: 10px;
              }
              
              .grid-item{
                font-size:16px;
              }
            }
            .course-image {
                order: -1; /* Moves the image to the top */
            }

          `}
        </style>
        {/* User Journey Section */}
        {/* <div
          style={{
            padding: "10px 10px",
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "80vw",
              marginTop: "20px",
              borderRadius: "20px",
            }}
          >
            <p
              className="course-title"
              style={{
                fontFamily: "Aclonica",
                textAlign: "center",
              }}
            >
              Your User Journey to Success
            </p>
            <div className="home-roadmap-section"></div>
          </div>
        </div> */}
        {/* Aptitude Evaluation Test Section */}

        {/* <div
          style={{
            width: "80%",
            padding: "10px 10px",
            margin: "20px auto",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "white",
            borderRadius: "10px",
            boxShadow:
              " 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          <HomeAptitude course={aptitudeTestData} />
        </div> */}
        {/* Statistics Section */}
        <div class="stats-section">
          <div class="row">
            <div class="col-4 col-md-3 stats-col">
              <div class="stat-box yellow">
                <div class="counter-wrapper ">
                  <Counter targetNumber={100000} />
                </div>
                <p class="stat-text user-interactions">
                  User
                  <br />
                  Interactions
                </p>
              </div>
              <div class="stat-box purple" style={{ marginTop: "20px" }}>
                <div class="counter-wrapper">
                  <Counter targetNumber={25000} />
                </div>
                <p class="stat-text total-users">Total direct/indirect Users</p>
              </div>
            </div>
            <div class="col-4 col-md-6 image-col">
              <div>
                <picture class="inner-image">
                  <source
                    media="(max-width: 768px)"
                    srcset="working-gif3.gif"
                  />
                  <source
                    media="(min-width: 769px)"
                    srcset="working-gif4.gif"
                  />
                  <img
                    src="working-gif4.gif"
                    class="employee-image"
                    alt="Employee Onboarding"
                  />
                </picture>
              </div>
            </div>
            <div class="col-4 col-md-3 stats-col">
              <div class="stat-box green">
                <div class="counter-wrapper">
                  <Counter targetNumber={25} />
                </div>
                <p class="stat-text collaborations">
                  Collaborations
                  <br /> / Affiliations
                </p>
              </div>
              <div class="stat-box red" style={{ marginTop: "20px" }}>
                <div class="counter-wrapper">
                  <Counter targetNumber={50} />
                </div>
                <p class="stat-text interns">Interns till date</p>
              </div>
            </div>
          </div>
        </div>
        <FloatingButtons />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
